import React from 'react';
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-[#fff8e1] text-gray-400 py-6">
      <div className="max-w-7xl mx-auto px-6 flex flex-col md:flex-row justify-between items-center text-sm">
        <p>© {new Date().getFullYear()} Ethio Cyber Talent All rights reserved.</p>
        <div className="space-x-4 mt-2 md:mt-0">
          <Link to="/program" className="hover:text-white transition duration-300">Program</Link>
          <Link to="/contact" className="hover:text-white transition duration-300">Contact</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
